import { config } from '@config';
import { findLocationSearch } from '@utils/location-search';
import { defineModel } from 'foca';
import { Network } from 'turbos-clmm-sdk';

const initialState: {
  coinTypeA: string;
  coinTypeB: string;
} = {
  coinTypeA: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',
  coinTypeB:
    config.sui_network === Network.mainnet
      ? '0x2::sui::SUI'
      : '0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7::DBUSDC::DBUSDC',
};

export const swapCoinModel = defineModel('swap-coin', {
  initialState,
  reducers: {
    updateA(state, coinType: string) {
      state.coinTypeA = coinType;
    },
    updateB(state, coinType: string) {
      state.coinTypeB = coinType;
    },
    exchange(state) {
      return {
        coinTypeA: state.coinTypeB,
        coinTypeB: state.coinTypeA,
      };
    },
  },
  events: {
    onInit() {
      const hash = window.location.hash.replace(/.*\?/, '');
      const search = window.location.search.replace(/^\?/, '');
      if (search) {
        const input = findLocationSearch(search, 'input');
        const output = findLocationSearch(search, 'output');
        if (input) {
          this.updateA(input);
        }
        if (output) {
          this.updateB(output);
        }
      } else if (hash) {
        const input = findLocationSearch(hash, 'input');
        const output = findLocationSearch(hash, 'output');
        if (input) {
          this.updateA(input);
        }
        if (output) {
          this.updateB(output);
        }
      }
    },
  },
});
